import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap4-modal';

import { REG_EXP } from 'constants/index';
import { getUserId } from 'constants/localStorageManager';
import UsersApi from 'apis/Users';
import 'assets/scss/soonoGetStarted.css';
import 'assets/scss/confirmation-modal.css';
import Toaster from '../../Toaster';

class UpdateEmail extends React.Component {
  constructor() {
    super();
    this.state = {
      formValues: {
        confirmEmail: {},
        updateEmail: {},
      },
    };
  }

  validateEmails = () => {
    const { formValues } = this.state;
    const _formValues = { ...formValues };
    const { updateEmail, confirmEmail } = _formValues;
    let emailsValid = true;

    updateEmail.error = '';
    confirmEmail.error = '';
    if (!REG_EXP.EMAIL.test(updateEmail.value)) {
      updateEmail.error = 'Invalid Email';
      emailsValid = false;
    }

    if (!REG_EXP.EMAIL.test(confirmEmail.value)) {
      confirmEmail.error = 'Invalid Email';
      emailsValid = false;
    }

    if (updateEmail.value !== confirmEmail.value) {
      updateEmail.error = 'Emails do not match';
      confirmEmail.error = 'Emails do not match';
      emailsValid = false;
    }

    this.setState({
      formValues: { ..._formValues },
    });

    return emailsValid;
  };

  handleChange = e => {
    const { name, value } = e.target;
    const { formValues } = this.state;
    const _formValues = { ...formValues };
    _formValues[name].value = value;

    this.setState({ formValues: _formValues });
  };

  handleEmailUpdate = () => {
    const { toggleConfirmationSent, email } = this.props;
    const { formValues } = this.state;
    const new_email = formValues.updateEmail.value;
    const user = {
      email,
      new_email,
    };

    if (this.validateEmails()) {
      UsersApi.updateEmail(user)
        .then(() => {
          this.setState({ email: new_email });
          toggleConfirmationSent(new_email);
          Toaster.getSuccessToaster(
            'check-circle',
            'Email Updated Successfully'
          );
        })
        .catch(({ response }) => {
          const hasError =
            response &&
            response.data &&
            response.data.email &&
            response.data.email[0] &&
            response.data.email[0].error === 'taken';
          const errorMessage = hasError
            ? 'Email is already taken'
            : 'Failed to update email';

          Toaster.getErrorToaster('exclamation-triangle', errorMessage);
        });
    }
  };

  render() {
    const {
      isVisible,
      toggleModal,
      toggleEmailConfirmation,
      email,
    } = this.props;
    const { formValues } = this.state;
    const { confirmEmail, updateEmail } = formValues;

    return (
      <Modal
        className="confirmation-modal confirmation-modal-reset-email"
        visible={isVisible}
      >
        <div className="modal-header text-center">
          <h2 class="modal-title d-inline text-bold">
            Update your email address
          </h2>
          <a
            className="close-onboarding-modal"
            onClick={e => {
              e.preventDefault();
              toggleModal();
            }}
          >
            <FontAwesomeIcon icon="times" />
          </a>
        </div>
        <div className="modal-body text-center pt-3 pb-3">
          <div className="text-left">
            <form className="form mt-2 mb-3 text-left text-dark soono-transaction-form">
              <label>
                Current Email: <span className="text-primary">{email}</span>
              </label>
              <hr></hr>
              <div class="form-group">
                <label for="InputEmail">New Email</label>
                <input
                  type="email"
                  class="form-control p-4 pl-4 pr-4"
                  id="InputEmail"
                  placeholder="xyz@gmail.com"
                  name="updateEmail"
                  onChange={this.handleChange}
                  value={updateEmail.value}
                />
                {updateEmail.error && (
                  <div className="row error">{updateEmail.error}</div>
                )}
              </div>
              <div class="form-group">
                <label for="InputEmailConfirm">Confirm Email</label>
                <input
                  type="email"
                  class="form-control p-4"
                  id="InputEmailConfirm"
                  name="confirmEmail"
                  value={confirmEmail.value}
                  onChange={this.handleChange}
                  placeholder=""
                />
                {confirmEmail.error && (
                  <div className="row error">{confirmEmail.error}</div>
                )}
              </div>
            </form>
          </div>
          <button
            onClick={this.handleEmailUpdate}
            className="btn btn-warning col-sm-12 btn-sm py-3 pl-5 pr-5 text-white text-bold border-0 mb-2"
          >
            SEND CONFIRMATION EMAIL
          </button>
          <p>
            <span className="cursor-pointer" onClick={toggleEmailConfirmation}>
              Do not change my current email address
            </span>
          </p>
        </div>
      </Modal>
    );
  }
}

UpdateEmail.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
};

export default UpdateEmail;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/Modal/UpdateEmail.js